import { library } from "@fortawesome/fontawesome-svg-core";

import {
	faTelegram as fabTelegram
} from '@fortawesome/free-brands-svg-icons'
//import {
//	faEnvelope as farEnvelope,
//	faFloppyDisk as farFloppyDisk
//} from '@fortawesome/free-regular-svg-icons';
import {
	faChevronLeft as fasChevronLeft,
	faSave as fasSave,
	faPen as fasPen,
	faPlus as fasPlus,
	faRocket as fasRocket,
	faTrash as fasTrash,
	faUser as fasUser,
	faSignInAlt as fasSignInAlt,
	faTrashCan as fasTrashCan,
	faEye as fasEye,
	faEyeSlash as fasEyeSlash,
	faCog as fasCog
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
	fabTelegram,
	fasChevronLeft,
	fasSave,
	fasPen,
	fasPlus,
	fasRocket,
	fasTrash,
	fasUser,
	fasSignInAlt,
	fasTrashCan,
	fasEye,
	fasEyeSlash,
	fasCog
);

export { FontAwesomeIcon };
